
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 3.053C2 2.47 2.471 2 3.053 2h7.491c.531 0 .98.395 1.045.922L13.43 17.66a1.053 1.053 0 01-1.044 1.183H3.053A1.053 1.053 0 012 17.79V3.053zm4.404 4.061A.614.614 0 017 6.65h1.228c.282 0 .527.192.596.465l1.842 7.369a.614.614 0 01-1.192.297l-.65-2.605h-2.42l-.65 2.605a.614.614 0 01-1.192-.297l1.842-7.369zm.308 3.833h1.804l-.767-3.07h-.27l-.767 3.07z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.42 22a2.105 2.105 0 01-2.104-2.105h5.123c.633 0 1.123-.555 1.045-1.183L12.658 4.105h7.237c1.162 0 2.105.943 2.105 2.106v13.684A2.105 2.105 0 0119.895 22H10.42zm7.896-13.158a.526.526 0 00-1.053 0v1.053h-2.105a.526.526 0 100 1.052h.58c.134.704.531 1.652 1.359 2.62a7.133 7.133 0 01-1.648 1.12.526.526 0 00.47.942 8.165 8.165 0 001.912-1.308 10.22 10.22 0 001.803 1.294.526.526 0 10.522-.914 9.185 9.185 0 01-1.606-1.148 7.735 7.735 0 001.318-2.44.528.528 0 00.027-.166h.526a.526.526 0 000-1.052h-2.105V8.842zm.495 2.105H16.818c.126.475.417 1.133.997 1.839.452-.583.77-1.208.996-1.839z"}})])
          )
        }
      }
    